import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import "./../../bindings/bao-upload";
function ConfigurationItemTypeUploadIconDialog(tabPage, parent) {
    var self = this;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogViewModel.Upload().then(function () {
                    self.DialogResult("ok");
                    self.Dialog.Close();
                });
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogResult = ko.observable();
    self.DialogViewModel.Upload = function () { };
    self.DialogViewModel.DocumentName = ko.observable();
    self.DialogViewModel.ConfigurationItemTypeId = ko.observable();
    self.Show = function (configurationItemTypeId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemType/ShowConfigurationItemTypeUploadIconDialog", JSON.stringify({
            sessionTabId: tabPage.SessionTabId,
            configurationItemTypeId: configurationItemTypeId
        }), function (value) {
            self.DialogViewModel.ConfigurationItemTypeId(configurationItemTypeId);
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.DocumentName() == null || self.DialogViewModel.DocumentName() == "") {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
export default ConfigurationItemTypeUploadIconDialog;